import styled from "styled-components";
import { colors } from "../../styles/variables";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledParagraph = styled.div`
  padding-top: 30px;
  margin-bottom: 60px;
  color: ${colors.gray600};
`;
